// App.jsx — Routes + global chrome
import React from "react";
import { Routes, Route, useLocation, Link } from "react-router-dom";
import { useTweaks } from "./hooks/useTweaks.js";
import { useT } from "./i18n/useT.js";

import Nav from "./components/Nav.jsx";
import Footer from "./components/Footer.jsx";
import Tweaks from "./components/Tweaks.jsx";
import KonamiEgg from "./components/KonamiEgg.jsx";

import PageHome from "./pages/Home.jsx";
import PageStudio from "./pages/Studio.jsx";
import PageServices from "./pages/ServicesPage.jsx";
import PagePortfolio from "./pages/PortfolioPage.jsx";
import PageWorkshops from "./pages/WorkshopsPage.jsx";
import PageShop from "./pages/ShopPage.jsx";
import PageBlog from "./pages/BlogPage.jsx";
import PageContact from "./pages/ContactPage.jsx";

function NotFound() {
  return (
    <section style={{ padding: "200px 32px 120px", textAlign: "center", maxWidth: 720, margin: "0 auto" }}>
      <div style={{ fontFamily: "'Press Start 2P', monospace", fontSize: 22, color: "var(--ragross-magenta)", letterSpacing: "0.20em", marginBottom: 16 }}>
        404 · STAGE NOT FOUND
      </div>
      <p style={{ font: "var(--type-body-lg)", color: "var(--fg-2)", marginBottom: 24 }}>
        Esta sala no existe en el cartucho. Vuelve al inicio para seguir explorando.
      </p>
      <Link to="/" className="btn btn-primary">▸ VOLVER AL INICIO</Link>
    </section>
  );
}

// Scroll to top on route change
function ScrollReset() {
  const { pathname } = useLocation();
  React.useEffect(() => { window.scrollTo({ top: 0, behavior: "auto" }); }, [pathname]);
  return null;
}

export default function App() {
  const [s] = useTweaks();
  const { pathname } = useLocation();

  React.useEffect(() => {
    const b = document.body;
    b.setAttribute("data-display", s.displayFont || "space");
    b.setAttribute("data-mode", s.mode || "arcade");
    b.setAttribute("data-anim", s.animations === false ? "off" : "on");
    b.setAttribute("data-viewport", s.viewport || "desktop");
    document.documentElement.lang = s.lang || "es";
  }, [s.displayFont, s.mode, s.animations, s.viewport, s.lang]);

  React.useEffect(() => {
    const title = ({
      "/":            "Ragross Studios — Estudio de videojuegos en Cali",
      "/estudio":     "El Estudio · Ragross Studios",
      "/servicios":   "Servicios · Ragross Studios",
      "/portafolio":  "Portafolio · Ragross Studios",
      "/talleres":    "Talleres · Ragross Studios",
      "/tienda":      "Tienda · Ragross Studios",
      "/blog":        "Blog · Ragross Studios",
      "/contacto":    "Contacto · Ragross Studios",
    })[pathname] || "Ragross Studios";
    document.title = title;
  }, [pathname]);

  return (
    <>
      <div className="app-aura"></div>
      <div className="stage">
        <Nav />
        <ScrollReset />
        <main key={pathname} className="page-enter">
          <Routes>
            <Route path="/" element={<PageHome />} />
            <Route path="/estudio" element={<PageStudio />} />
            <Route path="/servicios" element={<PageServices />} />
            <Route path="/portafolio" element={<PagePortfolio />} />
            <Route path="/talleres" element={<PageWorkshops />} />
            <Route path="/tienda" element={<PageShop />} />
            <Route path="/blog" element={<PageBlog />} />
            <Route path="/contacto" element={<PageContact />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
      </div>

      <Tweaks />
      <KonamiEgg />
    </>
  );
}
